import { CloseIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useMutation } from 'react-query'
import { useEffect, useState } from 'react'
import { api } from '../../../../services/api'
import { Login } from './Login'
import { ObservacaoLiberacao } from './ObservacaoLiberacao'

const schema = z.object({
  nome: z.string().nonempty(),
  senha: z.string().nonempty(),
})

async function liberarCotacao({ nome_liberador, senha_usuario }) {
  const response = await api.post(
    '/site/v2/fluxo-liberacao/verifica-dados-liberador',
    {
      nome_liberador,
      senha_usuario,
    },
  )

  return response.data
}

export function ModalAutorizacao({ isOpen, onClose, numero_pedido, refresh }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  })

  const [step, setStep] = useState(2)

  async function onSubmit(data) {
    const params = {
      nome_liberador: data.nome,
      senha_usuario: data.senha,
    }

    try {
      await mutateAsync(params)
    } catch (error) {
      console.log(error)
    }
  }

  const toast = useToast({
    position: 'top',
    duration: 5000,
    isClosable: true,
  })

  const { data, mutateAsync } = useMutation({
    mutationFn: liberarCotacao,
    onSuccess: () => setStep(2),
    onError: (error) => {
      toast({
        title: 'Erro ao tentar liberar a cotação',
        description: 'Verifique os dados e tente novamente',
        status: 'error',
      })
    },
  })

  const renderingStep = {
    1: <Login submitForm={handleSubmit(onSubmit)} register={register} />,
    2: (
      <ObservacaoLiberacao
        numero_pedido={numero_pedido}
        refresh={refresh}
        onClose={onClose}
        nome_liberador={data?.nome_liberador}
        codigo_liberador={data?.codigo_liberador}
      />
    ),
  }

  useEffect(() => {
    if (!isOpen) {
      setStep(1)
    }
  }, [isOpen])

  return (
    <Flex
      display={isOpen ? 'flex' : 'none'}
      position="fixed"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      zIndex={999}
    >
      <Box
        color="white"
        w="600px"
        h="200px"
        p={3}
        bg="#e9e9e9"
        transition="all 0.2s"
        fontFamily={'Roboto, sans-serif'}
        display="flex"
        justifyContent="center"
        alignItems="center"
        boxShadow="0px 0px 1px 0px rgba(0,0,0,0.75)"
        borderRadius="5px"
        flexDirection="column"
      >
        <CloseIcon
          position={'absolute'}
          right={'10px'}
          top={'10px'}
          cursor={'pointer'}
          color={'#95c620'}
          onClick={onClose}
        />
        <Text
          as="h2"
          fontSize="1rem"
          fontWeight="bold"
          color="#222222"
          textAlign="center"
          marginBottom="1rem"
        >
          Pedir liberação ao supervisor
        </Text>

        {renderingStep[step]}
      </Box>
    </Flex>
  )
}
